import { useCallback, useRef } from 'react';
import { capturePublicApi } from '../api/captureApi';
import type { CaptureFunnelStep } from '../api/captureApi';

/**
 * Fire-and-forget funnel step reporting for the patient capture wizard.
 *
 * Tracking must never block or break the patient's flow, so failures are
 * swallowed. The server dedupes per (invite, step); the local `sent` set just
 * saves a redundant round-trip when the patient taps Back and walks a screen
 * again. The `rating` step is exempt because a re-tapped star changes which
 * branch the patient takes, and the server needs to hear about it.
 */
export function useFunnelTracker(shortCode: string | undefined) {
  const sent = useRef(new Set<CaptureFunnelStep>());

  return useCallback(
    (step: CaptureFunnelStep, rating?: number) => {
      if (!shortCode) return;
      if (step !== 'rating' && sent.current.has(step)) return;
      sent.current.add(step);
      capturePublicApi.trackStep(shortCode, step, rating).catch((err: unknown) => {
        console.debug('trackStep failed', err);
      });
    },
    [shortCode],
  );
}
